import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SettingItemWithCheckbox } from '../Common/SettingItemWithCheckbox'
import { getNewSportsSetting } from '../../Store/selectors'
import { setNewSportsSetting } from '../../Store'

export const NewSportsSetting = () => {
  const dispatch = useDispatch()
  const isSettingEnabled = useSelector(getNewSportsSetting)

  return (
    <SettingItemWithCheckbox
      isEnabled={isSettingEnabled}
      label='New Sports'
      desciption='Enables new sports feature'
      onToggle={() => {
        dispatch(setNewSportsSetting(!isSettingEnabled))
      }}
    />
  )
}
